// Drops replies that land after the chat moved on. fetchUsingApi takes no abort signal, so a counter does the job.
//   const token = gate.next();          // before the await
//   const result = await api();
//   if (!gate.isCurrent(token)) return; // Cancel or a newer request came first
export interface RequestGate {
  next: () => number;
  isCurrent: (token: number) => boolean;
}

export const createRequestGate = (): RequestGate => {
  let current = 0;
  return {
    next: () => ++current,
    isCurrent: (token) => token === current,
  };
};
